import { ActionType } from "typesafe-actions";

export const isActionType = (type: any) => (action: ActionType<any>): boolean =>
  action.type === type;

export const isOneOfActionTypes = (types: any[]) => (action: ActionType<any>): boolean =>
  types.includes(action.type);
